
import { Component, Mixins, Prop } from "vue-property-decorator"

import SubscriptionScheme from '@/shared/enums/SubscriptionScheme'

import ValidatorMixin from "@/shared/mixins/validator/ValidatorMixin"

import CheckoutForm from "../models/CheckoutForm"
import { dateTimeFromServer, formatAmount } from '../utils/format'
import ETaxIdInput from "./TaxIdInput.vue"

@Component({
  components: {
    ETaxIdInput,
  },
})
export default class SubscriptionForm extends Mixins(ValidatorMixin) {
  @Prop() readonly data!: CheckoutForm

  readonly person = this.data.person;
  readonly payment = this.data.payment;
  readonly subscription = this.data.subscription!;
  readonly formattedDueDate = dateTimeFromServer(this.subscription.dueDate, false)
  readonly formattedEndDate = dateTimeFromServer(this.subscription.endDate, false)
  readonly isAmountFixed = this.subscription.amountType === 'FIXED'
  readonly initialCharge = this.subscription.initialCharge

  get formattedAmount() {
    if (this.isAmountFixed) {
      return formatAmount(this.subscription.amount)
    }

    if (this.subscription.minimumAmount) {
      return formatAmount(this.subscription.minimumAmount);
    }

    return null
  }

  get dueTodayAmount() {
    if (!this.initialCharge) {
      return formatAmount(0)
    }
    return this.payment.amount;
  }

  get isSubscribingByPix(): boolean {
    return this.data.subscription?.scheme === SubscriptionScheme.pixAutomatico;
  }
}
